import customSelect from 'custom-select';
import initHeaderSelectors, { initOpenSubmenu } from './cpHeaderSelectors';
import { initHeaderScroll, initBurgerButton } from './headerBehaviour';
import initAccordeonMenu from './footerBehaviour';
import initEventProgramSlider from './cpEventProgramSlider';
import initCountdown from './cpCountdownBanner';
import initBackToTop from './cpBackToTop';
import initEventsList from './cpEventsList';
import initSpeakersList from './cpSpeakersList';
import initSpeakersSlider from './cpSpeakersSlider';
import initAnimationsCountdown from './cpAnimationsCountdown';
import initBackgroundBanner from './cpBackgroundBanner';
import initMediacenterList from './cpMediacenterList';
import initMediasSlider from './cpMediasSlider';
import initSocialShare from './cpToggleSocialShare';
import initVideoBannerHero from './cpVideoBannerHero';
import initSliderVideosBanner from './cpSliderVideosBanner';
import initImageGallery from './cpImageGallery';
import initContentImageSlider from './cpContentImageSlider';
import initCrossContentTextSlider from './cpCrossContentTextSlider';
import initSimpleSpeakerSlider from './cpSimpleSpeakerSlider';
import initPastTradeShowsList from './cpPastTradeShowsList';
import initShowCard from './cpShowCards';
import initGetTwitterContent from './getTwitterContent';
import initOffersSearchForm from './cpOffersSearchForm';
import initSearch from './cpSearch';
import initLiveConf from './liveConf/initLiveConf';
import smoothLink from '../utils/smoothLink'

export default function () {
  customSelect('.js-custom-select');

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  window.addEventListener('resize', () => {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  initHeaderSelectors();
  initHeaderScroll();
  initBurgerButton();
  initEventProgramSlider();
  initCountdown();
  initBackToTop();
  initEventsList();
  initSpeakersList();
  initSpeakersSlider();
  initAnimationsCountdown();
  initBackgroundBanner();
  initMediacenterList();
  initMediasSlider();
  initSocialShare();
  initVideoBannerHero();
  initSliderVideosBanner();
  initImageGallery();
  initAccordeonMenu();
  initContentImageSlider();
  initCrossContentTextSlider();
  initSimpleSpeakerSlider();
  initPastTradeShowsList();
  initShowCard();
  initGetTwitterContent();
  initOffersSearchForm();
  initOpenSubmenu();
  initSearch();
  initLiveConf();
  smoothLink();
}
